"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTableResizeHandle_unstable", {
    enumerable: true,
    get: ()=>useTableResizeHandle_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const useTableResizeHandle_unstable = (props, ref)=>{
    const onClick = (0, _reactUtilities.useEventCallback)((event)=>{
        var _props_onClick;
        (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props, event);
        event.stopPropagation();
    });
    return {
        components: {
            root: 'div'
        },
        root: (0, _reactUtilities.getNativeElementProps)('div', {
            ref,
            ...props,
            onClick
        })
    };
}; //# sourceMappingURL=useTableResizeHandle.js.map

//# sourceMappingURL=useTableResizeHandle.js.map